import React from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const AdminLayout = () => {
  return (
    <div className="flex h-screen bg-white">
      <Sidebar />

      {/* Main Content */}
      <div className="flex-1 flex flex-col w-full overflow-hidden">
        <header className="bg-white border-b border-gray-300 h-16 hidden lg:block"></header>
        <main className="flex-1 overflow-auto overflow-x-hidden p-3 sm:p-4 lg:p-8">
          <Outlet />
        </main>
      </div>

      {/* Toast Notifications */}
      <ToastContainer
        position="top-right"
        autoClose={4000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        style={{
          '--toastify-color-light': '#ffffff',
          '--toastify-color-dark': '#0a0a0a',
        }}
      />
    </div>
  );
};

export default AdminLayout;
